import { MakeCall } from './createMakeCall';
import { ListingPhoto } from './types/Listing';

const getListingPhotos = (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingPhoto[]>('GET', `/api/v2/listing/${listingId}/photos`);
export { getListingPhotos };
